import http from '@/biz/http.mjs'
import Table from '@/biz/Table'
import {Alert, useOpenModal} from '@/components/Modal'
import {useChooseStatic} from '@/hooks/useChoose.jsx'
import runAsync from '@/script/runAsync.mjs'

const useChooseDbIns = () => {
    const choose = useChooseStatic({title: '选择数据库实例'})

    const columns = [
        {
            title: '实例名称',
            dataIndex: 'dbInsName',
            dataType: 'text',
        },
        {
            title: '环境',
            dataIndex: 'dbInsEnv',
            dataType: 'text',
        },
        {
            title: 'IP',
            dataIndex: 'dbInsIntranetIp',
            dataType: 'text',
        },
        {
            title: '端口',
            dataIndex: 'dbInsPort',
            dataType: 'number',
        },
    ]

    return dataSource => choose({columns, dataSource})
}

export default () => {
    const openModal = useOpenModal()
    const chooseDbIns = useChooseDbIns()

    return (map, nodes) => {
        if (1 < nodes.size) {
            return null
        }

        const onClick = async () => {
            const [dt] = nodes
            const {dbId, pkid: dtId} = dt.data

            const dbInss = await runAsync(
                () => http.get('/ins/enableQuery', {dbId}),
                {action: '读取数据库实例'}
            )

            const readTable = async ({dtId, pkid}) => {
                const {
                    dmDfs,
                    dmDt,
                    resultSet: dataSource,
                } = await runAsync(
                    () => http.post('/ins/sampleData', {dtId, pkid}),
                    {action: '读取表数据'}
                )

                const columns = dmDfs.map(
                    ({
                        dfAlias,
                        dfName,
                        dfUserCode,
                    }) => ({
                        dataIndex: dfUserCode,
                        dataType: 'text',
                        title: `${dfAlias || dfName}\n${dfUserCode}`,
                        width: 100,
                    })
                )

                const {dtAlias, dtName, dtUserCode} = dmDt
                const title = `${dtAlias || dtName} ${dtUserCode}`
                return {columns, dataSource, title}
            }

            const openModalTable = async ({dtId, pkid}) => {
                const {columns, dataSource, title} = await readTable(
                    {dtId, pkid}
                )

                openModal(
                    <Alert
                        overflow="hidden"
                        title={title}
                        width={1200}
                    >
                        <Table
                            code={`db-table-sample-data_${dtId}`}
                            columns={columns}
                            dataSource={dataSource}
                        />
                    </Alert>
                )
            }

            if (0 === dbInss.length) {
                openModal(
                    <Alert type="error">未找到数据库实例</Alert>
                )
            }
            else if (1 === dbInss.length) {
                const [{pkid}] = dbInss
                openModalTable({dtId, pkid})
            }
            else {
                const dbIns = await chooseDbIns(dbInss)

                if (! dbIns) {
                    return
                }

                const {pkid} = dbIns
                openModalTable({dtId, pkid})
            }
        }

        return {
            label: '查询数据',
            onClick,
        }
    }
}
